
import { bucketStore, eventCompanyStore, eventStore, mainStore } from '@/store';
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import NoData from './NoData.vue';
import EventItem from '../calendar/EventItem.vue';
import PopupEventItem from '../dashboard/PopupEventItem.vue';

@Component({
  components: {
    NoData,
    PopupEventItem,
    EventItem,
  },
})
export default class Suggestions extends Vue {
  @Prop({ default: false }) readonly isLoading;

  public componentLoading = false;
  public selectedEvent = {};
  public nextEventsByDepartures: any = [];

  get loading() {
    return this.isLoading || this.componentLoading;
  }

  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }

  get currentUser() {
    return mainStore.userProfile;
  }

  get avatares() {
    return bucketStore.files;
  }

  get events() {
    let events = eventCompanyStore.eventCompanies;
    if (this.avatares.length > 0) {
      events = events.map((event) => {
        const userAvatar = this.avatares.find((a: any) => a.blob.id === event.colaborador_id);
        if (userAvatar) {
          event['avatar'] = userAvatar['download_url'];
        }
        return event;
      });
    }
    return events;
  }

  @Emit('openEvent')
  public openNextEvent(item) {
    const form: any = this.$refs.showNextEvent;
    this.selectedEvent = item;
    form.show(item);
    return item;
  }

  public async mounted() {
    if (!this.currentUser) return;
    this.componentLoading = true;
    this.nextEventsByDepartures = await eventStore.getNextEventsByDepartures([2, 4, 5, 9, 52]);
    this.componentLoading = false;
  }
}
